var DefinitionType;

(function (DefinitionType) {
  DefinitionType["query"] = "query";
  DefinitionType["mutation"] = "mutation";
})(DefinitionType || (DefinitionType = {}));

function isQueryDefinition(e) {
  return e.type === DefinitionType.query;
}
function isMutationDefinition(e) {
  return e.type === DefinitionType.mutation;
}
function calculateProvidedBy(description, result, queryArg, assertEntityTypes) {
  if (isFunction(description)) {
    return description(result, queryArg).map(expandEntityDescription).map(assertEntityTypes);
  }

  if (Array.isArray(description)) {
    return description.map(expandEntityDescription).map(assertEntityTypes);
  }

  return [];
}

function isFunction(t) {
  return typeof t === 'function';
}

function expandEntityDescription(description) {
  return typeof description === 'string' ? {
    type: description
  } : description;
}

export { DefinitionType, calculateProvidedBy, isMutationDefinition, isQueryDefinition };
//# sourceMappingURL=endpointDefinitions.js.map
